import React, { useEffect, useState } from 'react';
import { Company } from './Tabs/Company';
import { BCAside } from './BCAside';
import { Users } from './Tabs/Users';
import { Attestations } from './Tabs/Attestations';
import { Addresses } from './Tabs/Addresses';
import { Orders } from './Tabs/Orders';
import { translate } from '../../Services/translation';
import { Invoices } from './Tabs/Invoices';
import { getQueryParam, setUrlParameter } from "./helpers/urlHelpers";
import { DeclinedOrders } from "./Tabs/DeclinedOrders";

export const BusinessCentralMyPages = () => {
  const [selectedTab, setSelectedTab] = useState(getQueryParam('page') ?? 'company');

  useEffect(() => {
    setUrlParameter('page', selectedTab);
  }, [selectedTab]);

  const tabs = {
    company: {
      name: translate('business.sidebar.companytab'),
      component: <Company />,
      icon: 'company',
    },
    adresses: {
      name: translate('business.sidebar.addressestab'),
      component: <Addresses />,
      icon: 'addresses',
    },
    users: {
      name: translate('business.sidebar.userstab'),
      component: <Users />,
      icon: 'users',
    },
    attestations: {
      name: translate('business.sidebar.attestationtab'),
      component: <Attestations />,
      icon: 'attestation',
    },
    orders: {
      name: translate('business.sidebar.orderstab'),
      component: <Orders />,
      icon: 'orders',
    },
    declinedOrders: {
      name: translate('business.sidebar.declinedorderstab'),
      component: <DeclinedOrders />,
      icon: 'orders',
    },
    invoices: {
      name: translate('business.sidebar.invoicetab'),
      component: <Invoices />,
      icon: 'invoices',
    },
  };

  return (
    <div className="BusinessCentral__container">
      <BCAside
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
        tabs={tabs}
      />
      <div className="BusinessCentral__content">
        {tabs[selectedTab].component}
      </div>
    </div>
  );
};
